import Vue from 'vue'
import store from '../vuex/store'
import * as actions from '../vuex/actions'
import querystring from 'querystring'
import storejs from 'storejs'
import qs from 'qs'
import axios from 'axios'
import { Indicator } from 'mint-ui'
import Router from 'vue-router'

let base = '//test.api.kalading.com/v1/';
let ymbase = '//test.api.kalading.com/';
let base_user = '//test.api.user.kalading.com/v1/';
let siteUrl = '//test.m.kalading.com/';
// let env = 'dev';
if(env == 'dev') {
	base = '//dev.api.kalading.com/v1/';
	ymbase = '//dev.api.kalading.com/';
	base_user = '//dev.api.user.kalading.com/v1/';
	siteUrl = '//dev.m.kalading.com/';
}
else if(env == 'test'){
	base = '//test.api.kalading.com/v1/';
	ymbase = '//test.api.kalading.com/';
	base_user = '//test.api.user.kalading.com/v1/';
	siteUrl = '//test.m.kalading.com/';
}
else if(env == 'pre') {
	base = '//pre.api.kalading.com/v1/';
	ymbase = '//pre.api.kalading.com/';
	base_user = '//pre.api.user.kalading.com/v1/';
	siteUrl = '//pre.m.kalading.com/';
}
else if(env == 'prod') {
	base = '//api.kalading.com/v1/';
	ymbase = '//api.kalading.com/';
	base_user = '//user.kalading.com/v1/';
	siteUrl = '//kalading.com/';
}
else if(env == 'local') {
	base = '//api.dev.com/v1/';
	ymbase = '//api.dev.com/';
	base_user = '//user.dev.com/v1/';
	siteUrl = '//frontend.dev.com/';
}
export {
	base_user,
	siteUrl
}

//在线客服地址
export const kefuUrl = "//kalading.udesk.cn/im_client/";
//httprequest拦截器
axios.defaults.timeout = 1000 * 35;
//客户电话
export const kefuTel = "400-006-8181";
// 判断是否存在token，如果存在的话，则每个http header都加上token
// axios 配置
var requestCount = 0;
axios.interceptors.request.use(
	config => {
		if (!config.url.includes('ym/get-card')) { //获取亿美信息不需要加载中
			requestCount++;
			Indicator.open({
				text: '加载中...',
				spinnerType: 'fading-circle'
			});
		}
		(!!!config.data) && (config.data = []);
		let vm = new Vue();
		config.data["from"] = 'wap';
		var TOKEN = vm.getCookie("token");
		var UUID = vm.getCookie("uuid");
		vm = null;
		if (TOKEN) {
			config.data["access-token"] = `${TOKEN}`;
		}
		if (UUID) {
			config.data["uuid"] = `${UUID}`;
		}
		config.data = querystring.encode(config.data);
		if (config.method === 'get') {
			config.url +=`?${config.data}`
		}
		return config;
	},
	err => {
		Indicator.close();
		return Promise.reject(err);
	}
);
//拦截器

let res = axios.interceptors.response.use(
	response => {
		requestCount-- ;
		if(requestCount === 0){
			setTimeout(()=>{
				Indicator.close()
			},1000)
		}
		return response;
	},
	error => {
		console.log(error.response)
		Indicator.close();
		if (error.response) {
			switch (error.response.status) {
				case 401:
					// 返回 401 清除token信息并跳转到登录页面
				localStorage.clear();
				let vm = new Vue()
				vm.delCookie("token");
				const router = new Router()
				router.push({
					path: '/login'
				})
			}
		}
		return error.response   // 返回接口返回的错误信息
	});
/****获取焦点图*****/
export const getIndexBanner = params => { return axios.post(`${base}slider/lists`, params) };

/****获取可以服务的城市*****/
export const getServerCity = params => { return axios.post(`${base}city/can-serve`, params); }

/****获取热门车辆品牌*****/
export const getHotAutoBrand = params => { return axios.post(`${base}auto/get-hot-brand-list`, params); }
/****搜索车辆车型和品牌****/
export const searchAuto = params => { return axios.post(`${base}auto/search`, params); }
/****搜索车系***/
export const seachModalList = params => { return axios.post(`${base}auto/get-brand-search`, params); }

/****获取车系列表*****/
export const getModalList = params => { return axios.post(`${base}auto/get-model-list`, params); }

/****获取排量列表****/
export const getEngineDisplacementList = params => { return axios.post(`${base}auto/get-engine-displacement-list`, params); }

/****获取年份列表***/
export const getPrductYearList = params => { return axios.post(`${base}auto/get-product-year-list`, params); }

/******获取具体车辆信息********/
export const getBaseInfo = params => { return axios.post(`${base}auto/get-base-info`, params); }

/****获取热门品牌*****/
export const getAutoBrand = params => { return axios.post(`${base}auto/get-brand-list`, params); }
/***找不到车辆***/
export const consultAdd = params => { return axios.post(`${base}consult/add`, params); }
/****添加用户车辆***/
export const addUserCar = params => { return axios.post(`${base}user-auto/add`, params); }
/****删除用户车辆***/
export const delUserCar = params => { return axios.post(`${base}user-auto/delete`, params); }
/****用户车辆详情***/
export const userAutoDetail = params => { return axios.post(`${base}user-auto/detail`, params) };
/****更新用户车辆详情***/
export const userAutoUpdate = params => { return axios.post(`${base}user-auto/update`, params); }
/******用户登录********/
export const loginIn = params => { return axios.post(`${base_user}auth/login`, params); }
/******中华联合财险用户验证********/
export const validateCustomer = params => { return axios.post(`${base}partner/validate-customer`, params); }
/******获取用户中秋优惠活动********/
export const getActivity = params => { return axios.post(`${base}activity/get-activity`, params); }
/******领取优惠活动********/
export const receiveCoupon = params => { return axios.post(`${base}user-coupon/receive-coupon`, params); }

/*****用户头像上传****/
export const uploadAvator = parmas => { return axios.post(`${base}user/upload-avatar`, parmas); }
/*******获取验证码*******/
export const getVerfiyCode = params => { return axios.post(`${base_user}auth/verify-code`, params); }

/****获取服务后台配置信息***/
export const configServiceData = params => { return axios.post(`${base}order/init`, params); }
/****服务计算价格****/
export const orderPrice = params => { return axios.post(`${base}order/price`, params); }
/****获取选择的服务信息*****/
export const getServices = params => { return axios.post(`${base}auto-service/get-services`, params); }

/****获取服务详情*****/
export const getServiceGroupInfo = params => { return axios.post(`${base}auto-service/get-service-group-info?group_id=` + params); }

/****热门服务搜索关键字*****/
export const getHotSearchService = params => { return axios.post(`${base}auto-service/hot-search`, params); }

/****服务搜索*****/
export const searchService = params => { return axios.post(`${base}auto-service/search`, params); }

/****用户中心*****/
export const getUserCenterInfo = params => { return axios.post(`${base}user/user-center`, params); }

/****更新用户信息****/
export const updateProfile = params => { return axios.post(`${base_user}user/update-profile`, params); }

/**** 用户车辆列表  ****/
export const getUserCarList = params => { return axios.post(`${base}user-auto/lists`, params); }
/***获取车辆的详细信息***/
export const getcarInfoById = params => { return axios.post(`${base}auto/get-base-info-by-id`, params); }
/****价格计算*****/
export const calcPrice = params => { return axios.post(`${base}order/price`, params); }
/***获取上门服务的地址***/
export const insideAddress = params => { return axios.post(`${base}order/depots`, params); }
/**** 添加用户地址 ****/
export const userAddAddress = (params) => { return axios.post(`${base_user}user/add-address`, params); }
/***获取用户默认地址***/
export const getDefaultAddress = params => { return axios.post(`${base_user}user/get-default-address`, params); }
/**** 获取用户地址 ****/
export const userAddressList = params => { return axios.post(`${base_user}user/addresses`, params); }
/**** 用户地址信息（包含地址所在城市是否可以服务）****/
export const userAddrList = params => { return axios.post(`${base}user/user-addr`, params); }

/**** 修改用户地址  ****/
export const userModifyAddress = params => { return axios.post(`${base_user}user/modify-address`, params); }
/**** 删除用户地址  ****/
export const userDeleteAddress = params => { return axios.post(`${base_user}user/delete-address`, params); }
/**** 设置用户默认地址  ****/
export const setDefaultAddress = params => { return axios.post(`${base_user}user/set-default-address`, params); }
/***获取可用优惠券列表***/
export const getUsableCoupons = params => { return axios.post(`${base}order/get-usable-coupons`, params); }
/**** 创建订单  ****/
export const createOrder = params => { return axios.post(`${base}order/create`, params); }
/****可下单日期获取*****/
export const getCanOrderDate = params => { return axios.post(`${base}capacity/get-can-order-date`, params); }
/****根据里程推荐服务***/
export const recommendServices = params => { return axios.post(`${base}auto-service/recommend-services`, params); }
/**** 订单列表  ****/
export const getOrderList = params => { return axios.post(`${base}user-order/get-order-list`, params); }
/**** 订单详情  ****/
export const getOrderInfo = params => { return axios.post(`${base}user-order/show`, params); }

/**** 订单追踪  ****/
export const getOrderProcess = params => { return axios.post(`${base}user-order/process`, params); }

/****取消订单****/
export const cancelOrder = parmas => { return axios.post(`${base}user-order/cancel`, parmas); }

/**** 支付  ****/
export const getPaymentParams = params => { return axios.post(`${base}payment/do-pay`, params); }

/**** 获取优惠券列表 ****/
export const getUserCoupon = params => { return axios.post(`${base}user-coupon/lists`, params); }
/***兑换优惠券****/
export const addUserCoupon = params => { return axios.post(`${base}user-coupon/add`, params); }

/***订单评价-获取技师信息***/
export const getAddInfo = params => { return axios.post(`${base}evaluate/get-add-info`, params); }
/***订单评价-获取评价list***/
export const getEvalList = parmas => { return axios.post(`${base}evaluate/get-list`, parmas); }
/***订单评价-获取评价分类***/
export const getEvalTypes = parmas => { return axios.post(`${base}evaluate/get-types`, parmas); }
/***订单评价-订单点赞***/
export const evaluateUp = parmas => { return axios.post(`${base}evaluate/up`, parmas); }
/***订单评价-保存评价***/
export const addEvaluate = params => { return axios.post(`${base}evaluate/add`, params); }
/***订单评价-上传图片****/
export const evaluatePicUpload = params => { return axios.post(`${base}evaluate/upload`, params); }
/***保养报告***/
export const getAutoMaintainList = params => { return axios.post(`${base}maintain/get-auto-maintain-list`, params); }
/***保养详情**/
export const getShowMaintain = params => { return axios.post(`${base}maintain/show`, params); }

/*
 *用户反馈
 */
/***添加反馈图片***/
export const saveFeedBackPic = params => { return axios.post(`${base}feedback/upload`, params); }
/***添加反馈意见***/
export const saveFeedBackContent = params => { return axios.post(`${base}feedback/add`, params); }

/*
* 保养提醒
*/
export const getRemindSetup = params => { return axios.post(`${base}maintain/get-remind-setup`, params); }
export const saveRemindSetup = params => { return axios.post(`${base}maintain/save-remind-setup`, params); }

/*
 * 获取车辆保养手册和原厂配件参数
*/
//获取车辆保养手册
export const getMaintainCycle = params => { return axios.post(`${base}auto-service/get-maintain-cycle`, params); }
//获取车辆原厂配件参数
export const getOilParam = params => { return axios.post(`${base}auto/get-oil-param`, params); }
/*
 * 发票获取与提交
 */
//发票获取
export const getCreateInfo = params => { return axios.post(`${base}invoice/get-create-info`, params); }
//发票提交
export const invoiceCreate = params => { return axios.post(`${base}invoice/create`, params); }

/****更新用户车辆详情***/
export const upgradeUserAuto = params => { return axios.post(`${base}user-auto/upgrade`, params); }

/****根据vin获取车型***/
export const baInfoAuto = params => { return axios.post(`${base}auto/ba-info`, params); }

/****根据ymToken获取信息***/
export const getCardInfo = params => { return axios.post(`${ymbase}third-party/ym/get-card?token=`+params.token, params); }

/***充值***/
export const recharge = params => { return axios.post(`${ymbase}third-party/ym/recharge`, params); }

/****根据图片获取vin***/
export const aiVehicleLicense = params => { return axios.post(`${base}ai/vehicle-license`, params); }

/****中华财险优惠券列表***/
export const getZHCXUserCoupons = params => { return axios.post(`${base}activity/get-user-coupons `, params); }

/****获取保养提醒列表***/
export const getMaintainNoticeList = params => { return axios.post(`${base}maintain-notice/list `, params); }
/****更新保养提醒时间***/
export const updateNoticeTime = params => { return axios.post(`${base}maintain-notice/update-notice-time `, params); }
/****获取优惠活动***/
export const joinEspecial = params => { return axios.post(`${base}activity/join-especial`, params); }
/****获取车型数据***/
export const getAutoBases = params => { return axios.post(`${base}auto/get-auto-bases`, params); }
/***获取可用活动****/
export const getActivityScene = params => { return axios.get(`${base}activity/get-activity-scene`, params); }
/***领取活动规则内优惠券****/
export const joinActivityScene = params => { return axios.post(`${base}activity/join-activity-scene`, params); }
/***判断是否需要再次选车****/
export const needSelectCarAgain = params => { return axios.post(`${base}auto/need-select-car-again`, params); }
/***获取消息提醒****/
export const noticeList = params => { return axios.post(`${base}city/wechat-notice`, params); }
/***根据客户类别获取虚拟门店****/
export const getVshop = params => { return axios.post(`${base}partner/vshop`, params); }

/***获取Wx进店小程序参数****/
export const getWxShopAppUrlScheme = params => { return axios.post(`${base}wechat/get-shop-app-url-scheme`, params); }

// 龙珠保单验证接口
export const longzhuVerifyInsurance = params => { return axios.get(`${base}insurance/longzhu-verify`, { params: params }); }


// WEBPACK FOOTER //
// ./src/api/api.js